<template>
    <b-input-group-append>
        <b-input-group-text>
            <b-icon :icon="icon"/>
        </b-input-group-text>
    </b-input-group-append>
</template>

<script>
export default {
    name: "BInputGroupAppendIcon",
    props: {
        icon: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
